import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
 providedIn: 'root'
})
export class ForwardFinanceService {
	private postBody: {};
	httpRes: any;
	public quote = {};
  public quotation: any = [{P_AMOUNT: 0, PAYMENT_DATE: ''}];
  public email: string;
  public payment_date: string;
  public totalrequest: number = 0;
  public feesexvat: number = 0;
  public feesincvat: number = 0;
  public feesvat: number = 0;
  public totalcost: number = 0;
  public loading: boolean = false;
  public accepting: boolean = false;

	constructor(private http: HttpClient) {}

  async getQuote(quote: [], paydate: string, lS: any) {
    this.loading = true;
    var p = {
      "producer": +lS.selectedmember,
      "season": +lS.season,
      "ffquote": quote,
      "paydate": paydate
    };
    var response = await lS.loadData('getFFQuotes', p);
    this.quotation = response['quote'];
    this.email = response['email'];
    this.payment_date = response['payment_date'];
    this.totalrequest = 0;
    this.feesexvat = 0;
    this.feesincvat = 0;
    this.feesvat = 0;
    this.totalcost = 0;
    for (var i=0; i<this.quotation.length; i++) {
      this.totalrequest += +this.quotation[i]['P_AMOUNT'];
      this.feesexvat += +this.quotation[i]['P_FEES_EX_VAT'];
      this.feesincvat += +this.quotation[i]['P_FEES_INCL_VAT'];
      this.feesvat += +this.quotation[i]['P_FEES_VAT'];
      this.totalcost += +this.quotation[i]['P_REPAYMENT_AMOUNT'];
    }
    this.loading = false;
  }

  async acceptQuote(quote: [], paydate: string, lS: any) {
    this.accepting = true;
    var p = {
      "producer": +lS.selectedmember,
      "season": +lS.season,
      "ffquote": quote,
      "paydate": paydate
    };
    var response = await lS.loadData('acceptFFQuotes', p);
    this.accepting = false;
    return response;
  }


}